// 全局资源管理器 - 限制同时播放的设备数量，增强版本
const ResourceManager = {
  // 八窗口布局需要同时播 8 路；过低会导致后几路注册失败、画面闪断
  maxConcurrentPlayers: 8,
  activePlayers: new Map(), // 改为Map存储更多信息
  pendingCleanup: new Set(), // 待清理的播放器

  canStartNewPlayer: () => {
    const activeCount = ResourceManager.activePlayers.size - ResourceManager.pendingCleanup.size;
    return activeCount < ResourceManager.maxConcurrentPlayers;
  },

  registerPlayer: (playerId) => {
    // 如果正在清理，先等待清理完成
    if (ResourceManager.pendingCleanup.has(playerId)) {
      console.log(`播放器 ${playerId} 正在清理中，等待清理完成...`);
      return false;
    }

    if (ResourceManager.canStartNewPlayer()) {
      ResourceManager.activePlayers.set(playerId, {
        registeredAt: Date.now(),
        status: 'registered'
      });
      console.log(`播放器 ${playerId} 已注册，当前活跃: ${ResourceManager.getActiveCount()}/${ResourceManager.maxConcurrentPlayers}`);
      return true;
    }
    console.log(`无法注册播放器 ${playerId}，已达到最大限制`);
    return false;
  },

  unregisterPlayer: (playerId) => {
    if (ResourceManager.activePlayers.has(playerId)) {
      // 标记为待清理状态
      ResourceManager.pendingCleanup.add(playerId);

      // 延迟真正移除，确保所有异步清理操作完成
      setTimeout(() => {
        ResourceManager.activePlayers.delete(playerId);
        ResourceManager.pendingCleanup.delete(playerId);
        console.log(`播放器 ${playerId} 已注销并清理完成，当前活跃: ${ResourceManager.getActiveCount()}/${ResourceManager.maxConcurrentPlayers}`);
      }, 500); // 500ms延迟确保清理完成

      console.log(`播放器 ${playerId} 开始注销过程...`);
    }
  },

  getActiveCount: () => {
    return ResourceManager.activePlayers.size - ResourceManager.pendingCleanup.size;
  },

  // 新增：强制清理无效的播放器
  forceCleanup: () => {
    const now = Date.now();
    const maxAge = 5 * 60 * 1000; // 5分钟

    for (const [playerId, info] of ResourceManager.activePlayers.entries()) {
      if (now - info.registeredAt > maxAge) {
        console.log(`强制清理超时播放器: ${playerId}`);
        ResourceManager.unregisterPlayer(playerId);
      }
    }
  },

  // 新增：获取详细状态
  getStatus: () => {
    return {
      active: ResourceManager.getActiveCount(),
      max: ResourceManager.maxConcurrentPlayers,
      registered: ResourceManager.activePlayers.size,
      cleaning: ResourceManager.pendingCleanup.size,
      players: Array.from(ResourceManager.activePlayers.keys())
    };
  }
};

export default ResourceManager;
